import React from 'react'
import moment from 'moment-timezone'
import classnames from 'classnames'
import tzData from 'timezones-json'
import Select from './Select'

const SelectTimezone = (props) => {
  return (
    <Select {...props} className={classnames('SelectTimezone', props.className)}>
      {tzData.timezones.map(timezone =>
        <optgroup label={timezone.group} key={timezone.group}>
          {timezone.zones.map(zone =>
            <option value={zone.value} key={zone.value}>
              {zone.name}
            </option>
          )}
        </optgroup>
      )}
    </Select>
  )
}

SelectTimezone.displayName = 'SelectTimezone'

// static default helper
SelectTimezone.guessTimezone = () => {
  const guess = (zone) => zone.value === moment.tz.guess()
  const timezone = tzData.timezones.find(timezone => timezone.zones.find(guess))
  return timezone ? timezone.zones.find(guess).value : null
}

export default SelectTimezone



// WEBPACK FOOTER //
// ./src/lib/form/SelectTimezone.js